import {
  VStack,
  Text,
  HStack,
  AccordionItem,
  AccordionHeader,
  AccordionContent,
  AccordionTrigger
} from "@gluestack-ui/themed";

import { Icon } from "@repo/core/components/core/Icon";

import { CardInfoCollapseProps } from "./types";
import { useCardInfoCollapseController } from "./controller";

export const CardInfoCollapse = ({
  id,
  title = "",
  subtitle = "",
  items,
  isActive
}: CardInfoCollapseProps) => {
  const { bgColor, borderColor } = useCardInfoCollapseController({
    isActive
  });

  return (
    <AccordionItem
      borderRadius="$lg"
      borderColor={borderColor}
      backgroundColor={bgColor}
      borderWidth={1}
      value={id}
      gap={0}
      minHeight={56}
    >
      <AccordionHeader mb="$0">
        {isActive ? (
          <VStack
            position="absolute"
            top={10}
            right={10}
            justifyContent="center"
            alignItems="center"
          >
            <Icon
              name="check-circle"
              variant="solid"
              size={20}
              color="$primary700"
            />
          </VStack>
        ) : null}
        <HStack w="$full" p="$2" gap="$3" position="relative">
          <AccordionTrigger py="$0" px="$0" w="$full">
            <VStack
              flex={1}
              gap="$0.5"
              justifyContent="flex-start"
              alignItems="flex-start"
            >
              <Text fontSize="$sm" fontWeight={600} color="$textLight900">
                {title}
              </Text>
              <Text fontSize="$sm" fontWeight={400} color="$textLigh800">
                {subtitle}
              </Text>
            </VStack>
          </AccordionTrigger>
        </HStack>
      </AccordionHeader>
      {items?.length ? (
        <AccordionContent mt="$0" pl="$3">
          <VStack pt="$2" gap="$2" overflow="hidden">
            {items?.map((item, index) => (
              <HStack gap="$2" key={index} flex={1}>
                <VStack w="$3" pt="$0.5">
                  <Icon
                    name="check"
                    variant="regular"
                    size={12}
                    color="$primary700"
                  />
                </VStack>
                <HStack>
                  <Text fontSize="$xs" fontWeight={500} color="$textLigh800">
                    {item}
                  </Text>
                </HStack>
              </HStack>
            ))}
          </VStack>
        </AccordionContent>
      ) : (
        <></>
      )}
    </AccordionItem>
  );
};
